import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';
import { decode } from 'base64-arraybuffer';

@Injectable({
    providedIn: 'root',
})
export class MobileCameraService {
    private readonly PICTURE_QUALITY = 70;

    private readonly PICTURE_WIDTH = 1200;

    private readonly ALLOW_EDITING = false;

    async openCamera(): Promise<Blob> {
        const cameraPhoto = await this.getPhoto(CameraSource.Camera);
        return this.convertFileToBlob(cameraPhoto);
    }

    async getPhotoFromLibrary(): Promise<Blob> {
        const cameraPhoto = await this.getPhoto(CameraSource.Photos);
        return this.convertFileToBlob(cameraPhoto);
    }

    private async getPhoto(source: CameraSource): Promise<Photo> {
        return Camera.getPhoto({
            quality: this.PICTURE_QUALITY,
            allowEditing: this.ALLOW_EDITING,
            width: this.PICTURE_WIDTH,
            resultType: CameraResultType.Base64,
            source,
        });
    }

    private async convertFileToBlob(photo: Photo): Promise<Blob> {
        return new Blob([new Uint8Array(decode(photo.base64String))], {
            type: `image/${photo.format}`,
        });
    }
}
